module.exports = __webpack_public_path__ + "img/drying_1200x800.585417ab.svg";